export const MY_ACCOUNT_PATH = '/my-account';

export default [
	{
		path: MY_ACCOUNT_PATH,
		lazy: async () => {
			const Module = await import('../../pages/MyAccount');
			return { Component: Module.default };
		},
	},
];
